<script>
export default {
  props: {
    agentTargetList: Array
  },
  data() {
    return {
      checkBoxSelect: true,
      addManageRange: false,
      addManageRangeArray: [
        {
          label: "年度",
          keyName: "year",
          type: "select",
          children: [
            {
              label: "2019",
              keyName: "2019"
            },
            {
              label: "2020",
              keyName: "2020"
            }
          ]
        },
        {
          label: "销售目标",
          keyName: "targetNumber",
          type: "number"
        }
      ]
    };
  },
  methods: {
    async onAddTarget(form) {
      // console.log("Enter onAddTarget: ", form);
      const updateData = {
        agentId: this.$route.params.agentId,
        year: form.year,
        targetNumber: form.targetNumber
      };
      const result = await this.$http.regionAddAgentYearTarget(updateData);
      if (result === "success") {
        console.log("save success");
      }
    },
    onClickEditBeginLevel(row) {
      row.editRow = true;
    },
    async EditBeginLevel(row, save) {
      if (save) {
        const agentId = this.$route.params.agentId;
        const formData = {
          agentAchievementId: row.id,
          remark: row.formValue
        };
        let data = await this.$http.regionUpdateAgentTarget(
          agentId,
          formData,
          true
        );
        if (data === "success") {
          this.$message.success("提交成功");
          row.remark = row.formValue;
          row.editRow = false;
        } else {
          this.$message.success("保存失败，请重试");
          ow.formValue = row.remark;
          row.editRow = false;
        }
      } else {
        row.formValue = row.remark;
        row.editRow = false;
      }
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    }
  }
};
</script>

<template>
  <div class="AgentDetailYearTargetIndex">
    <DialogForm
      v-if="addManageRange"
      formTitle="添加年度目标"
      :formInputArray="addManageRangeArray"
      @close="addManageRange = false"
      @submitForm="onAddTarget"
    />
    <elementButton size="medium" @click="addManageRange = true">添加年度目标</elementButton>
    <el-table
      :data="agentTargetList"
      class="AgencyAccountTable"
      :header-cell-style="{ 'padding-left': '5px',color: 'rgba(0,0,0,0.65)','font-size': '14px', 'background-color': '#fafafa !important'}"
      :cell-style="{'padding-left': '5px'}"
    >
      <el-table-column prop="year" align="left" label="年度" width="150"></el-table-column>
      <el-table-column prop="targetNumber" align="left" label="销售目标(疗程)" width="150"></el-table-column>
      <el-table-column prop="actualNumber" align="left" label="实际销量(疗程)" width="150"></el-table-column>
      <el-table-column prop="finishScore" align="left" label="完成程度" width="150"></el-table-column>
      <el-table-column prop="remark" align="left" label="备注">
        <template slot-scope="scope">
          <span
            v-if="scope.row.editRow === false"
            class="editLevelSpan"
            @click="onClickEditBeginLevel(scope.row)"
          >
            {{scope.row.remark}}
            <i class="el-icon-edit editIcon"></i>
          </span>
          <span v-else class="editRowLevel">
            <el-input
              v-model="scope.row.formValue"
              type="textarea"
              :rows="2"
              size="mini"
              class="numberInput"
            ></el-input>
            <el-button
              @click="EditBeginLevel(scope.row,true)"
              size="mini"
              class="saveButton"
              type="primary"
            >保存</el-button>
            <el-button @click="EditBeginLevel(scope.row, false)" size="mini" class="cancelButton">取消</el-button>
          </span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<style lang="scss">
@import "@/css/color.scss";

.AgentDetailYearTargetIndex {
  .AgencyAccountTable {
    margin: 20px auto;
    border: 1px;
    width: 97%;
    .checkBoxLabel {
      color: #303133;
      .el-checkbox__input.is-disabled + span.el-checkbox__label {
        color: #303133;
      }
    }
    .el-table__body tr:hover > td {
      background-color: #e6f7ff !important;
      cursor: pointer;
    }

    .el-table__body tr.current-row > td {
      background-color: #e6f7ff !important;
      cursor: pointer;
    }
    .editLevelSpan {
      cursor: pointer;
      min-width: 200px;
      .editIcon {
        margin-left: 5px;
        color: #00c1de;
      }
    }
    .editRowLevel {
      display: inline-block;
      text-align: center;
      .numberInput {
        min-width: 80px;
      }
      .saveButton {
        background-color: #00c1de;
        border-color: #00c1de;
        color: #fff;
        margin-top: 5px;
      }
      .cancelButton {
        margin-top: 5px;
      }
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/components/Agent/AgentManageRange.vue